import ChevronRight from '@assets/icons/chevron-right-thin.svg';
import { createStyles } from '@/contexts/theme-context';
import {
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { TYPOGRAPHY } from '@/styles';

export enum PaymentCarouselOptionType {
  AutopayEnrollment = 'autopay-enrollment',
  AutopayError = 'autopay-error',
  NextAutopay = 'next-autopay',
  NextPaymentPlan = 'next-payment-plan',
  NoPaymentMethod = 'no-payment-method',
}

export interface PaymentCarouselData {
  content: React.ReactNode;
  Icon?: React.ReactNode;
  onPress?: () => void;
  rightText?: string;
  type: PaymentCarouselOptionType;
}

interface Props extends PaymentCarouselData {
  customStyles?: StyleProp<ViewStyle>;
}

export const PaymentBanner: React.FC<Props> = ({
  content,
  customStyles,
  Icon,
  rightText,
  onPress,
}) => {
  const [styles, theme] = useStyles();

  return (
    <TouchableOpacity
      disabled={!onPress}
      onPress={onPress}
      style={customStyles}
    >
      <View style={styles.flexRow}>
        <View style={styles.contentRow}>
          {Icon ? Icon : <View style={styles.iconPlaceholder} />}
          <View style={styles.contentWrapperFlex}>{content}</View>
        </View>
        <View style={styles.flexRow}>
          {rightText ? (
            <Text style={[TYPOGRAPHY.pBold, styles.rightText]}>
              {rightText}
            </Text>
          ) : null}
          {onPress ? (
            <View style={styles.chevron}>
              <ChevronRight
                height={16}
                stroke={theme.sk.color.icon.primary}
                width={16}
              />
            </View>
          ) : null}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  chevron: {
    marginLeft: 8,
  },
  contentRow: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
  },
  contentWrapperFlex: {
    flex: 1,
  },
  flexRow: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  iconPlaceholder: {
    height: 24,
  },
  rightText: {
    fontSize: theme.fontSizes.small,
  },
}));
